<table class="table table-striped table-hover">
	<thead>
		<tr class="table-dark">
			<th>Data</th>
			<th>Osoba</th>
			<th>Kategoria</th>
			<th>Informacja</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of history">
			<td>
				{{ item.date }}
			</td>
			<td>
				{{ item.user }}
			</td>
			<td>
				{{ item.category }}
			</td>
			<td>
				{{ item.message }}
			</td>
		</tr>
	</tbody>
</table>
